import { UniversalImporterImportProcessMetadataInput } from 'generated/resources/graphql'

import { Metadata, MetadataType, MetadataValueType } from './types'

const getMetadataType = (values: MetadataValueType[]): MetadataType => {
  if (values.length === 0) return 'string'

  const firstValue = values[0]
  switch (typeof firstValue) {
    case 'bigint':
      return 'integer'
    case 'boolean':
      return 'boolean'
    default:
      return 'string'
  }
}

export const useGetMetadata = (metadata: Metadata = {}) => {
  const metadataInput: UniversalImporterImportProcessMetadataInput[] = Object.entries(metadata).map(
    ([key, values]) => ({
      key,
      values: values.map((value) => String(value)),
      type: getMetadataType(values),
    })
  )

  const legalEntitiesIds = (() => {
    if (metadataInput.length === 0) return []
    const legalEntityMetadata = metadataInput.find((item) => item.key === 'legal_entity_ids')
    if (
      !legalEntityMetadata ||
      !legalEntityMetadata.values ||
      legalEntityMetadata.values.length === 0
    ) {
      return []
    }
    return legalEntityMetadata.values
  })()

  return { metadataInput, legalEntitiesIds }
}

const parseMetadataValue = (value: string, type: MetadataType): MetadataValueType => {
  switch (type) {
    case 'integer':
      return BigInt(value)
    case 'boolean':
      return value === 'true'
    case 'string':
    default:
      return value
  }
}

export const metadataInputToMetadata = (
  metadataInput: UniversalImporterImportProcessMetadataInput[]
): Metadata => {
  return metadataInput.reduce<Metadata>((acc, item) => {
    if (item.values && item.values.length > 0) {
      acc[item.key] = item.values.map((value) => parseMetadataValue(value, item.type))
    }
    return acc
  }, {})
}
